export default class PerthTime {
	constructor() {
		this.elements = document.querySelectorAll('.perthTime')
		this.timeoutId = null
		if (!this.elements.length) return

		this.formatter = new Intl.DateTimeFormat('en-AU', {
			timeZone: 'Australia/Perth',
			hour: '2-digit',
			minute: '2-digit',
			hour12: true,
		})

		this.#updateTime()
	}

	#updateTime() {
		const time = this.formatter.format(new Date())

		this.elements.forEach(el => {
			el.textContent = time
		})

		const now = new Date()
		const delay = (60 - now.getSeconds()) * 1000

		this.timeoutId = setTimeout(() => this.#updateTime(), delay)
	}

	destroy() {
		if (this.timeoutId) clearTimeout(this.timeoutId)
		this.timeoutId = null
	}
}
